/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import {
  Paper, Typography, Box,
} from '@mui/material';
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { alpha, styled } from '@mui/material/styles';

const paperSx = {
  width: '100%', // Fix IE 11 issue.
};
const textFildSx = {
  height: '100%',
  border: '0px',
};

const InputTextField = styled(OutlinedInput)({
  backgroundColor: '#ebebeb',
  borderRadius: '5px',
  borderWidth: 0,
  borderColor: '#transparent !important',
  '& input:valid + fieldset': {
    borderColor: 'transparent',
    borderWidth: 0,
  },
  '& input:invalid + fieldset': {
    borderColor: 'transparent',
    borderWidth: 0,
  },
  '& input:valid:focus + fieldset': {
    borderColor: 'transparent',
    borderWidth: 0,
  },
  '& input': {
    borderColor: 'transparent',
    borderWidth: 0,
  },
  '&.input#file': {
    display: 'none',
  },
  'input:-internal-autofill-selected': {
    backgroundColor: 'transparent !important',
    color: 'transparent !important',
    borderWidth: 0,
  },
  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent !important',
    borderWidth: 0,
  },
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
    borderWidth: 0,
  },
  '&.MuiOutlinedInput-root': {
    borderColor: 'transparent !important',
    borderWidth: 0,
    '&:hover fieldset': {
      borderColor: 'transparent',
      borderWidth: 0,
    },
  },
});

type _Input = OutlinedInputProps & {
    inputColor: string;
    labelSuperior: string;
    value: any;
    error: boolean;
    mensagem: string;
    placeHolder?: string;
    variant?: string;
    nameFile?: string;
}

export default function Input({
  nameFile = '', inputColor = '', labelSuperior = '', placeHolder = '', mensagem = '', error = false, ...rest
}: _Input) {
  const [visble, setVisble] = useState(false);
  const inputFocus = React.useRef<HTMLInputElement>();
  function changeType() {
    console.log(visble);
    setVisble(!visble);
  };

  function handleFocus(event: any) {
    // event.target.select();
    if (rest.type === 'file') {
      inputFocus.current?.click();
      inputFocus.current?.blur();
      console.log('click');
    }
  }
  return (
    <Box>
      <Typography style={{ color: inputColor }} fontSize={13}>
        {labelSuperior}
      </Typography>
      <InputTextField
        fullWidth
        id="teste"
        inputRef={inputFocus}
        size="small"
        variant="outlined"
        className="myclass"
        error={error}
        onFocus={handleFocus}
        endAdornment={(
            rest.type === 'password'
              ? (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => changeType()}
              // onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {visble ? <VisibilityOff /> : <Visibility /> }
                  </IconButton>
                </InputAdornment>
              ) : rest.type === 'file' ? (
                <InputAdornment position="end">
                  <Box sx={{ backgroundColor: '#ebebeb', zIndex: 5 }}>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => inputFocus.current?.click()}
              // onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      <AddPhotoAlternateIcon />
                    </IconButton>
                  </Box>
                </InputAdornment>
              ) : <></>
          )}
        {...rest}
        type={visble ? 'text' : rest.type}
      />
      {
          rest.type === 'file'
          && (
          <Box sx={{
            position: 'absolute',
            marginTop: '-32px',
            marginLeft: '10px',
            maxWidth: '250px',
          }}
          >
            <Typography sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            >
              {rest.value ? rest.value?.split('\\')[rest.value?.split('\\').length - 1] : nameFile}
            </Typography>
          </Box>
          )
      }
      {
          error
          && (
          <Typography style={{ color: 'red' }}>
            {mensagem}
          </Typography>
          )
      }
    </Box>
  );
}
